<script lang="ts">
  import { onMount } from "svelte";

  export let id = "";
  export let nonce = "";
  let scriptSrc;

  onMount(() => {
    if (!id) {
      return;
    }
    scriptSrc = "https://www.googleoptimize.com/optimize.js?id=" + id;
  });
</script>

<svelte:head>
  {#if scriptSrc}
    <script src={scriptSrc} {nonce} async></script>
  {/if}
</svelte:head>
